module.exports = __webpack_public_path__ + "static/img/kik.e9219c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kik.png
// module id = nii4
// module chunks = 1